import { isEmpty } from 'lodash'
import { ActionQueryModel } from '../../../model/app/master/action-query-model'
import { useCallback } from 'react'
import { create } from 'zustand'
import { descomprimirUrl } from '../../../utils/comprimir-dados'

interface ActionQueryStore {
    actionQueryValue: string | null
    setActionQuery: (query: string) => void
    clearActionQuery: () => void
    actionQueryObject: <T = any>() => ActionQueryModel<T> | null
}


export const useActionQueryStore = create<ActionQueryStore>((set, get) => ({
    actionQueryValue: null,

    setActionQuery: (query: string) => {
        set({ actionQueryValue: query })
    },

    clearActionQuery: () => {
        set({ actionQueryValue: null })
    },

    actionQueryObject: <T = any>() => {
        const getValue = get().actionQueryValue
        if (!getValue) return null
        let actionDecript = ''
        try {
            actionDecript = descomprimirUrl(getValue)
        } catch {
            actionDecript = atob(getValue)
        }
        return {
            ...JSON.parse(actionDecript)
        } as ActionQueryModel<T>
    }
}))

// Hook personalizado para facilitar o uso
export const useActionQuery = () => {
    const { actionQueryValue, setActionQuery, clearActionQuery, actionQueryObject } = useActionQueryStore()

    const handleActionQuery = useCallback(async () => {
        const actionQuery = actionQueryObject()
        switch (actionQuery?.type) {
        }
    }, [actionQueryObject])

    return {
        setActionQuery,
        clearActionQuery,
        hasActionQuery: !isEmpty(actionQueryValue),
        handleActionQuery
    }
}